import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Spin, Select, InputNumber, Divider, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import { counties } from "../../../counties";
import BreadCrumb from "../../../layout/BreadCrumb";
import {
  fetchCounties,
  fetchCrops,
  fetchData,
  fetchIrrigationType,
  fetchLoship,
  fetchSchemeType,
  fetchWaterSources,
} from "../../../features/fetch/fetchSlice"; 

const { TextArea } = Input;
const ExpressionAdd = ({ prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);

  const url = "api/v2/getFarmers";

  const { loading, data, counties, crops, wtrSources, schemeType,irrType,loship } =
    useSelector((state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      counties: state.fetch.counties,
      crops: state.fetch.crops,
      wtrSources: state.fetch.wtrSources,
      schemeType: state.fetch.schemeType,
      irrType:state.fetch.irrType,
      loship:state.fetch.loship,
    }));

    const { activeObjexpressions } = useSelector((state) => ({
       activeObjexpressions: state.obj.activeObj["expressions"],
     }));
    
 

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [countyName, setCountyName] = useState(activeObjexpressions?.countyName);
  function handleCancel() {
    navigate("/expression-of-interest");
  }
  const onFinish = async (data) => {
    data.projectId = activeObjexpressions?.projectId ? activeObjexpressions?.projectId : null;
    data.countyName = countyName;
    data.majorCrop = Array.isArray(data?.majorCrop)
      ? data?.majorCrop.join(",")
      : data?.majorCrop;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/flid/projects/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjexpressions,
    });
  }, [activeObjexpressions, form]);

  const initialFormValues = {
    ...activeObjexpressions,
    majorCrop: activeObjexpressions?.majorCrop ? activeObjexpressions?.majorCrop?.split(",") : [],
    usrId: activeObjexpressions?.usrId ? activeObjexpressions?.usrId : null,
  };

  async function fetchFarmersData() {
    await dispatch(
      fetchData({
        url: "api/v2/getFarmers",
        usrId:activeObjexpressions?.usrId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    setCountyName(activeObjexpressions?.countyName);
  }, [activeObjexpressions?.countyName]);

  useEffect(() => {
    fetchFarmersData();
    dispatch(fetchCounties());
    dispatch(fetchCrops());
    dispatch(fetchWaterSources());
    // dispatch(fetchSchemeType());
    dispatch(fetchIrrigationType())
    dispatch(fetchLoship())
  }, []);
 
  return (
    <div className="w-full ">
      <BreadCrumb
        breadcrumbs={[
          { title: "Expression List", path: "/expression-of-interest" },
          { title: "Expression Form" },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="form-add-h mb-[1.25rem]">
          Create an Expression of Interest
        </div>
        <Divider />
        <div className="w-full  mt-[1.75rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
          >
            <div className="flex items-center gap-x-5">
              <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                <span className="paragraph_paragraph_bb08">1</span>
              </div>
              <span className="paragraph_paragraph_bb13">Project Details</span>
            </div>

            <div className="ml-[5rem] ">
              <Form.Item
                name="usrId"
                className=""
                label={"Farmer"}
                rules={[
                  {
                    required: true,
                    message: "Please select farmer",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    data?.length > 0 &&
                    data?.map((item) => ({
                      value: item?.usrId,
                      label: item?.fullNames,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
            </div>
            <div className="ml-[5rem] grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              {/* <Form.Item
                name="projectName"
                label={"Project Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add project name",
                  },
                ]}
              >
                <Input placeholder="Project Name" className="input" />
              </Form.Item> */}
              <Form.Item
                name="countyId"
                className=""
                label={"County"}
                rules={[
                  {
                    required: true,
                    message: "Please select gender",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    counties?.length > 0 &&
                    counties?.map((item) => ({
                      value: item?.countyId,
                      label: item?.countyName,
                    }))
                  }
                  onChange={(value) => {
                    const selectedItem = counties?.find(
                      (item) => item?.countyId === value
                    );
                    setCountyName(selectedItem?.countyName || "");
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="location"
                className=""
                label={"Location"}
                rules={[
                  {
                    required: true,
                    message: "Please select location",
                  },
                ]}
              >
                <Input placeholder="Location" className="input" />
              </Form.Item>
            
              <Form.Item
                name="irrigationType"
                className=""
                label={"Irrigation Type"}
                rules={[
                  {
                    required: true,
                    message: "Please select Irrigation Type",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    irrType?.length > 0 &&
                    irrType?.map((item) => ({
                      value: item?.irrigationTypeName,
                      label: item?.irrigationTypeName,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="estimatedCost"
                label={"Estimated Cost"}
                rules={[
                  {
                    required: true,
                    message: "Please add Estimated Cost",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Ksh. e.g 500"
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="projectDescription"
                label={"Project Description"}
                rules={[
                  {
                    required: true,
                    message: "Please add project description",
                  },
                ]}
              >
                <TextArea
                  placeholder="Description..."
                  rows={5}
                  className="text_area"
                />
              </Form.Item>
            </div>
            <div className="flex items-center gap-x-5 mt-[2.38rem]">
              <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                <span className="paragraph_paragraph_bb08">2</span>
              </div>
              <span className="paragraph_paragraph_bb13">Farm Details</span>
            </div>
            <div className="ml-[5rem] grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="landOwnerShip"
                className=""
                label={"Land Ownership"}
                rules={[
                  {
                    required: true,
                    message: "Please select land ownership",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    loship?.length > 0 &&
                    loship?.map((item) => ({
                      value: item?.loName,
                      label: item?.loName,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="landSize"
                label={"land size (Acre)"}
                rules={[
                  {
                    required: true,
                    message: "Please add land size",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  max={5}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="land size"
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="landUse"
                label={"land in use (Acre)"}
                rules={[
                  {
                    required: true,
                    message: "Please add land in use",
                  },
                ]}
              >
                <Input placeholder="land in use" className="input" />
              </Form.Item>
              
              <Form.Item
                label={"Major Crops"}
                name="majorCrop"
                rules={[
                  {
                    required: true,
                    message: "Required field",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ height: "52px" }}
                  size="large"
                  className=""
                  dropdownRender={(menu) => (
                    <>
                      <Space style={{ padding: "8px 8px 4px" }}>
                        <span className="select-info mt-1">
                          Choose one or more of the following crops
                        </span>
                      </Space>
                      <Divider style={{ margin: "8px 0" }} />
                      {menu}
                    </>
                  )}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children?.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    )
                  }
                >
                  {crops?.length > 0 &&
                    crops?.map((item) => (
                      <Select.Option key={item?.cropId} value={item?.cropName}>
                        {item?.cropName}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </div>

            <div className="flex items-center gap-x-5 mt-[2.38rem]">
              <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                <span className="paragraph_paragraph_bb08">3</span>
              </div>
              <span className="paragraph_paragraph_bb13">
                Water Source Details
              </span>
            </div>

            <div className="ml-[5rem] grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="waterSource"
                className=""
                label={"Water Source"}
                rules={[
                  {
                    required: true,
                    message: "Please select water source",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    wtrSources?.length > 0 &&
                    wtrSources?.map((item) => ({
                      value: item?.wsName,
                      label: item?.wsName,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                  placeholder="select"
                />
              </Form.Item>
             
             
            </div>

            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button disabled={saving} key="submit" type="submit" className="cstm-btn-2">
                    {saving ? <Spin /> : activeObjexpressions?.projectId ? "Update" : "Create"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default ExpressionAdd;
